import { asset } from "@/lib/asset";
import {SectionBlock} from './SectionBlock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

export const NormalRead = ({ post, anchors }) => {
  const { lead_image, heading, content, date, sections } = post;

  return (
    <div className="row">
      {lead_image && (
        <div className="col-12 text-center xl:mt-[-15px]">
          <img src={asset(`/img/${lead_image}`)} className="img img-fluid w-[100%] h-auto rounded-[10px] xl:rounded-[20px]" loading="lazy" />
        </div>
      )}
      
      
      <h1 className="col-12 h1 text-2xl xl:text-3xl font-bold font-['Open Sans'] my-3 bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">{heading}</h1>
      
      <div className="col-12 text-italic d-css text-12px mb-1">
        {date}
      </div>

      {sections?.length > 0 && !sections[0]?.hide_intro && (
        <div className="col-12 text-italic mb-3">
          {content.join(' ')}
        </div>
      )}

      <div className="col-12 my-3">
        <h2 className="text-xl xl:text-2xl font-bold bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">
            {anchors?.length > 0 ? 'Содержание' : ''}
        </h2>
      </div>

      {anchors.map((section, k) => (
        <div key={k} className="col-12 flex flex-col gap-2 heading-link mb-1">
          <a href={`#${section.id}`} className="px-md-3 h3 font-bold font-[14px] text-underline">
            <FontAwesomeIcon icon={faAngleRight} className="ml-2 text-gray-500 text-sm" /> {section.title}
          </a>
          {section.subsections.map((subsection, k) => (
            <a key={`subsection-${k}`} href={`#${subsection.id}`} className="px-md-3 h3 font-bold font-[12px] text-underline">
              <FontAwesomeIcon icon={faAngleRight} className="ml-6 text-gray-500 text-xs" /> {subsection.title}
            </a>
          ))}
        </div>
      ))}

      {sections?.map((section, k) => (
        <SectionBlock 
          key={k} 
          section={section} 
          sec_id={`section-${k}`} 
        />
      ))}
    </div>
  );
};
